import { useMutation } from '@tanstack/react-query';
import { toast } from 'sonner';
import { GenerateForm } from './components/GenerateForm';
import { RecipeCard } from './components/RecipeCard';
import { generateMixes, generateRandomMixes } from './api';
import { useGenerateStore } from './store';
import type { GenerateRequest } from '@/shared/types';

export function GenerateTab(): JSX.Element {
  const { lastRecipes, setLastRecipes } = useGenerateStore();

  const generateMutation = useMutation({
    mutationFn: generateMixes,
    onSuccess: (data) => {
      setLastRecipes(data);
      toast.success(`Сгенерировано ${data.length} рецепта`);
    },
    onError: (error) => {
      toast.error(error instanceof Error ? error.message : 'Не удалось сгенерировать миксы');
    },
  });

  const randomMutation = useMutation({
    mutationFn: generateRandomMixes,
    onSuccess: (data) => {
      setLastRecipes(data);
      toast.success(`Сгенерировано ${data.length} случайных рецепта`);
    },
    onError: (error) => {
      toast.error(error instanceof Error ? error.message : 'Не удалось сгенерировать миксы');
    },
  });

  const handleGenerate = (request: GenerateRequest): void => {
    generateMutation.mutate(request);
  };

  const handleRandom = (request: Omit<GenerateRequest, 'ingredients' | 'constraints'>): void => {
    randomMutation.mutate(request);
  };

  const isLoading = generateMutation.isPending || randomMutation.isPending;

  return (
    <div className="space-y-6">
      <div className="rounded-2xl glass p-4">
        <GenerateForm
          onGenerate={handleGenerate}
          onRandom={handleRandom}
          isLoading={isLoading}
        />
      </div>

      {lastRecipes.length > 0 && (
        <div className="space-y-4">
          <h2 className="text-lg font-semibold text-slate-900 dark:text-slate-100">Варианты</h2>
          {lastRecipes.map((recipe, index) => (
            <RecipeCard key={recipe.id} recipe={recipe} index={index} />
          ))}
        </div>
      )}
    </div>
  );
}
